import { QuestionCircleOutlined } from '@ant-design/icons';
import { Row, Space, Tooltip, Typography } from 'antd';

interface TitleProps {
  title: string;
  tooltipText?: string;
}

const Title: React.FC<TitleProps> = ({ title, tooltipText = '' }) => {
  return (
    <Row>
      <Space size="small" align="center">
        <Typography.Title level={5}>{title}</Typography.Title>
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <Typography.Title level={5}>
              <QuestionCircleOutlined />
            </Typography.Title>
          </Tooltip>
        )}
      </Space>
    </Row>
  );
};

export default Title;
